<template>
  <v-tabs class="sub-menu" slider-color="primary" style="margin-bottom: 15px;">
    <v-tab class="sub-menu-item" to="/settings/role" exact>
      {{ $t("settings.rolesMenu.role") }}
    </v-tab>
    <v-tab
      class="sub-menu-item"
      to="/settings/role/deputy-auth"
      v-if="
        $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
          $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2
      "
    >
      {{ $t("settings.rolesMenu.delegatedPermissions") }}
    </v-tab>
    <v-tab
      to="/settings/role/mapping"
      class="sub-menu-item"
      v-if="
        $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
          $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2
      "
    >
      {{ $t("settings.rolesMenu.wnbRoleMapping") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/role/default">
      {{ $t("settings.rolesMenu.defaultRoles") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "RolesMenu"
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>
